"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
function getValuesToRender(fieldValue) {
    if (!fieldValue) {
        return [undefined];
    }
    if (lodash_1.isArray(fieldValue)) {
        return [...fieldValue, undefined];
    }
    return [fieldValue, undefined];
}
exports.default = getValuesToRender;
